import PT from 'prop-types';
import IPT from 'react-immutable-proptypes';
import { Component } from 'react';
import ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import isMobile from 'ismobilejs';
import _ from 'lodash';
import { WistiaPlayer } from 'edrolo/domains/video';
import WistiaUtils from 'edrolo/utils/WistiaUtils';
import Notes from './Notes';
import PdfViewer from './PdfViewer';
import Question from './Question';
import YouTubeVideo from './YouTubeVideo';
import SuccessMeasure from './SuccessMeasure';

import {
  chunkPropType,
  lessonPropType,
  quizAttemptPropType,
} from 'edrolo/domains/lessons/propTypes';

class Chunk extends Component {
  componentDidMount() {
    window.onresize = _.throttle(this.handleWindowResize, 100);
    this.handleWindowResize();
    this.viewChunk();
  }
  /* eslint-disable react/prop-types */ // TODO: add props

  componentDidUpdate(prevProps) {
    if (prevProps.chunk !== this.props.chunk) {
      this.viewChunk();
    }
  }

  componentWillUnmount() {
    window.onresize = null;
  }

  viewChunk() {
    this.props.recordChunkVisit(
      this.props.lesson.get('id'),
      this.props.chunk.get('id')
    );
  }

  handleVideoEnd = (closeFullScreenFn) => {
    if (this.props.chunk.get('question') || this.props.isLastChunk) {
      closeFullScreenFn();
    }

    if (!this.props.chunk.get('question')) {
      this.props.onChunkComplete();
    } else {
      this.props.onVideoEnd();
    }
  };

  // TODO: remove JS resizing
  handleWindowResize = () => {
    this.props.onChunkSizeKnown(
      // eslint-disable-next-line react/no-find-dom-node
      ($(ReactDOM.findDOMNode(this)).width() / 16) * 9
    );
  };

  get hasNotes() {
    return this.props.chunk.get('notes') || this.props.chunk.get('more_notes');
  }

  get showNotes() {
    return (
      !this.props.chunk.get('success_measure') &&
      !this.showVideo &&
      !this.showYoutube &&
      !this.showPdf &&
      !this.showQuestion &&
      this.hasNotes
    );
  }

  get showInteractiveActivity() {
    return (
      !this.props.chunk.get('success_measure') &&
      !this.showVideo &&
      !this.showYoutube &&
      !this.showQuestion &&
      this.props.chunk.get('interactive_activity') !== null
    );
  }

  get showQuestion() {
    return (
      !this.props.chunk.get('success_measure') &&
      !this.showVideo &&
      !this.showYoutube &&
      !this.showPdf &&
      this.props.chunk.get('question') !== null
    );
  }

  get showVideo() {
    return (
      !this.props.chunk.get('success_measure') &&
      this.props.chunk.get('video') !== null
    );
  }

  get showYoutube() {
    return (
      !this.props.chunk.get('success_measure') &&
      !this.showVideo &&
      !_.isEmpty(this.props.chunk.get('youtube_url'))
    );
  }

  get showPdf() {
    return (
      !this.props.chunk.get('success_measure') &&
      !this.showVideo &&
      !this.showYoutube &&
      !_.isEmpty(_.trim(this.props.chunk.get('pdf_url')))
    );
  }

  render() {
    return (
      <div className="chunk" style={{ minHeight: this.props.height }}>
        <ReactCSSTransitionGroup
          transitionName="chunk-fade"
          transitionAppear
          transitionAppearTimeout={200}
          transitionEnterTimeout={200}
          transitionLeaveTimeout={200}
        >
          {this.showVideo && (
            <WistiaPlayer
              videoHash={this.props.chunk.getIn(['video', 'wistia_hashed_id'])}
              thumbnailUrl={WistiaUtils.getThumbnail(
                this.props.chunk.get('video')
              )}
              autoPlay
              playButton={isMobile.any}
              playbackRate={this.props.playbackRate}
              onEnd={this.handleVideoEnd}
              height={this.props.height}
              origin="chunkview_v2"
              appLabel="tod"
              model="chunk"
              objectId={this.props.chunk.get('id')}
              introWistiaHash={
                this.props.chunk.get('is_first_in_lesson')
                  ? this.props.lesson.get('intro_wistia_hash')
                  : ''
              }
            />
          )}
          {this.showYoutube && (
            <YouTubeVideo
              url={this.props.chunk.get('youtube_url')}
              style={{ minHeight: this.props.height }}
            />
          )}
          {this.showPdf && (
            <PdfViewer
              url={this.props.chunk.get('pdf_url')}
              style={{ minHeight: this.props.height }}
            />
          )}
          {this.showQuestion && (
            <Question
              key={this.props.chunk.get('id')}
              lesson={this.props.lesson}
              question={this.props.chunk.get('question')}
              style={{ minHeight: this.props.height }}
              onResponseSave={this.props.onChunkComplete}
              lessonQuizAttempts={this.props.lessonQuizAttempts}
              saveQuizAttempt={this.props.saveQuizAttempt}
            />
          )}
          {this.showNotes && (
            <Notes
              chunk={this.props.chunk}
              isSlideshow={this.props.lesson.get('lesson_type') === 'SLIDES'}
              style={{ minHeight: this.props.height }}
            />
          )}

          {this.props.chunk.get('success_measure') && (
            <SuccessMeasure
              chunk={this.props.chunk}
              lessonId={this.props.lesson.get('id')}
              nextChunkUrl={this.props.nextChunkUrl}
              successMeasureChunks={this.props.successMeasureChunks}
            />
          )}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

Chunk.propTypes = {
  chunk: chunkPropType,
  height: PT.number,
  isLastChunk: PT.bool,
  lesson: lessonPropType,
  lessonQuizAttempts: IPT.listOf(quizAttemptPropType),
  nextChunkUrl: PT.string,
  onChunkComplete: PT.func,
  onChunkSizeKnown: PT.func,
  onVideoEnd: PT.func,
  recordChunkVisit: PT.func,
  playbackRate: PT.number,
  saveQuizAttempt: PT.func,
  successMeasureChunks: IPT.listOf(chunkPropType),
};

export default Chunk;
